"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParseDataStats = void 0;
var DataStats_1 = require("./Models/DataStats");
var ParseDataStats = /** @class */ (function () {
    function ParseDataStats() {
    }
    //cette methode recupere les bindings et identifie les colonnes label et data
    ParseDataStats.prototype.identifyColumns = function (bindings) {
        var _a;
        //column for our dataStats
        var dataColumn = "";
        var labelColumn = "";
        //loop through the bindings to identify the columns
        for (var _i = 0, bindings_1 = bindings; _i < bindings_1.length; _i++) {
            var bindingSet = bindings_1[_i];
            for (var key in bindingSet) {
                //check if the column is a label or data
                if (!((_a = bindingSet[key]) === null || _a === void 0 ? void 0 : _a.label)) {
                    //the key is the column name
                    console.log("key :", key);
                    dataColumn = key;
                }
                else {
                    //the key is the column name
                    console.log("key :", key);
                    labelColumn = key;
                }
            }
        }
        //return the identified columns 'couple of label and data columns'
        return { data: dataColumn, label: labelColumn };
    };
    //cette methode recupere les bindings et les mise selon une structure de données label,value using DataStats
    ParseDataStats.prototype.extractdata = function (Binding) {
        var _a;
        // Add your logic here to process the binding and return a value of type DataStats[]
        //declare an array of DataStats
        var dataStats = [];
        //idenitification des column
        var _b = this.identifyColumns(Binding), data = _b.data, label = _b.label;
        console.log("data :", data);
        console.log("label :", label);
        // Loop through the bindings
        for (var _i = 0, Binding_1 = Binding; _i < Binding_1.length; _i++) {
            var bindingSet = Binding_1[_i];
            // Create a new DataStats object
            var newDataStat = new DataStats_1.DataStats(((_a = bindingSet[label]) === null || _a === void 0 ? void 0 : _a.label) || "", parseInt(bindingSet[data].value));
            // Add the DataStats object to the array
            dataStats.push(newDataStat);
        }
        console.log("DataStats :", dataStats);
        return dataStats;
    };
    // cette methode recupere les dataStats et retourne les 19 premiers elements (maxValues on dataStats) et additionne les autres sous la propriété "Others"
    ParseDataStats.prototype.extractOnlyDataNeeded = function (dataStats, quantity, translations) {
        //declare an array of DataStats
        var topDataStats = [];
        //sort the dataStats by value
        //cela permet de recuperer les (quantity) premiers elements les plus grands
        dataStats.sort(function (a, b) { return b.value - a.value; });
        //une fois le array est trié, on recupere les 19 premiers elements
        //get the top (quantity) elements
        topDataStats = dataStats.slice(0, quantity);
        //ce qui reste des elements sera additionner sous la propriété "Others"
        //sum the rest of the elements
        var othersCount = dataStats.slice(quantity).reduce(function (sum, dataStat) {
            return sum + dataStat.value;
        }, 0);
        //add the "Others" entry if more than quantity entries
        if (dataStats.length > quantity) {
            topDataStats.push(new DataStats_1.DataStats("".concat(translations["others"]), othersCount));
        }
        //att the end we get the topDataStats "quantity elements"
        return topDataStats;
    };
    return ParseDataStats;
}());
exports.ParseDataStats = ParseDataStats;
